<template>
  <!-- 作为弹窗使用；如果你只要一个普通块，把 el-dialog 外层去掉即可 -->
  <el-dialog
    :visible.sync="innerVisible"
    width="780px"
    :close-on-click-modal="false"
    custom-class="dist-dialog"
    @open="fetchData"
    @close="$emit('update:visible', false)"
  >
    <template slot="title">
      <span>专家分配情况</span>
    </template>

    <div class="dist-wrap" v-loading="loading">
      <!-- 顶部 2x2 汇总卡片 -->
      <div class="summary-card">
        <div class="row head">
          <div class="cell">{{ categoryName }}</div>
          <div class="cell">数据</div>
        </div>
        <div class="row body">
          <div class="cell">专家 {{ expertNum }} 位</div>
          <div class="cell">{{ logsNum }} 条</div>
        </div>
      </div>

      <!-- 明细表 -->
      <el-table
        class="dist-table"
        :data="logs"
        border
        height="420"
        v-loading="loading"
        :header-cell-style="{ background: '#fafafa', color: '#606266' }"
        empty-text="暂无数据"
      >
        <el-table-column label="序号" type="index" width="80" align="center" />
        <el-table-column label="专家名称" prop="name" min-width="200" show-overflow-tooltip />
        <el-table-column label="主审数据" prop="primary_num" width="140" align="center" />
        <el-table-column label="副审数据" prop="secondary_num" width="140" align="center" />
      </el-table>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="innerVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 按你的路径引入接口
import {   getdistributeinfo } from "../utils/api.js";
export default {
  name: 'DistributeOverview',
  props: {
    // 弹窗显隐（.sync）
    visible: { type: Boolean, default: false },
    // 批次ID
    award_batch_id: { type: [String, Number], required: true },
    // 左上角分类标题（截图写的是“房屋市政建筑”）
    categoryName: { type: String, default: '房屋市政建筑' },
    wtype: { type: String, default: 'building' },
    // 自行注入请求函数（便于单元测试或复用）
  },
  data() {
    return {
      innerVisible: this.visible,
      loading: false,
      expertNum: 0,
      logsNum: 0,
      logs: [],
    };
  },
  watch: {
    visible(v) {
      this.innerVisible = v;
      if (v) this.$nextTick(this.fetchData);
    },
    award_batch_id() {
      if (this.innerVisible) this.fetchData();
    },
  },
  methods: {
    async fetchData() {
      if (!this.award_batch_id) return;
      this.loading = true;
      try {
        let res;
        res = await getdistributeinfo(this.award_batch_id,{wtype:this.wtype});

        // 兼容后端字段命名
        this.expertNum = Number(res.expert_num || 0);
        this.logsNum = Number(res.logs_num || 0);
        this.logs = res.logs ? res.logs : [];
        console.log('this.logs',this.logs);
      } catch (e) {
        this.$message.error('获取分配情况失败');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.dist-dialog ::v-deep(.el-dialog__header) {
  border-bottom: 1px solid #f0f0f0;
}
.dist-wrap { padding: 0 6px; }

/* 顶部汇总卡片 */
.summary-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;
}
.summary-card .row {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.summary-card .row.head {
  background: #f7f8fa;
  color: #606266;
  font-weight: 600;
  border-bottom: 1px solid #ebeef5;
}
.summary-card .row.body {
  background: #fff;
  color: #606266;
}
.summary-card .cell {
  padding: 14px 16px;
  border-right: 1px solid #ebeef5;
}
.summary-card .cell:last-child {
  border-right: 0;
}
.t-right { text-align: right; }

/* 表格 */
.dist-table { border-radius: 8px; }
</style>
